<template>
    <LoadingComponent :props="loading" />

    <div id="notification" class="db-card db-tab-div active" :class="{ 'on-update': onUpdateActive }">
        <div class="db-card-header items-center justify-between gap-4">
            <h3 class="db-card-title">{{ $t("menu.push_notifications") }} / {{ $t("label.firebase") }}</h3>
        
            <div class="flex items-center gap-2">
                <button
                    type="button"
                    class="db-btn h-9 py-2 px-3 text-white bg-primary ml-3"
                    @click="refreshFromServer"
                    :disabled="isRefreshingView"
                    :class="{ 'disabled:opacity-50 disabled:bg-gray': isRefreshingView }"
                >
                    <template v-if="isRefreshingView">
                        <svg class="inline-block animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                            <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                        </svg>
                    </template>
                    <template v-else>
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </template>
                </button>
            </div></div>
        <div class="db-card-body">
            <form @submit.prevent="save" class="w-full d-block">
                <div class="form-row">
                    <div class="form-col-12 sm:form-col-6">
                        <label for="notification_fcm_topic" class="db-field-title required">
                            {{ $t("label.notification_fcm_public_vapid_key") }}
                        </label>
                        <input v-model="form.notification_fcm_public_vapid_key"
                            v-bind:class="errors.notification_fcm_public_vapid_key ? 'invalid' : ''" type="text"
                            id="notification_fcm_topic" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.notification_fcm_public_vapid_key">{{
                            errors.notification_fcm_public_vapid_key[0]
                            }}</small>
                    </div>
                    <div class="form-col-12 sm:form-col-6">
                        <label for="notification_fcm_api_key" class="db-field-title required">
                            {{ $t("label.notification_fcm_api_key") }}
                        </label>
                        <input v-model="form.notification_fcm_api_key"
                            v-bind:class="errors.notification_fcm_api_key ? 'invalid' : ''" type="text"
                            id="notification_fcm_api_key" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.notification_fcm_api_key">{{
                            errors.notification_fcm_api_key[0]
                        }}</small>
                    </div>
                    <div class="form-col-12 sm:form-col-6">
                        <label for="notification_fcm_auth_domain" class="db-field-title required">
                            {{ $t("label.notification_fcm_auth_domain") }}
                        </label>
                        <input v-model="form.notification_fcm_auth_domain"
                            v-bind:class="errors.notification_fcm_auth_domain ? 'invalid' : ''" type="text"
                            id="notification_fcm_auth_domain" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.notification_fcm_auth_domain">{{
                            errors.notification_fcm_auth_domain[0]
                        }}</small>
                    </div>
                    <div class="form-col-12 sm:form-col-6">
                        <label for="notification_fcm_project_id" class="db-field-title required">
                            {{ $t("label.notification_fcm_project_id") }}
                        </label>
                        <input v-model="form.notification_fcm_project_id"
                            v-bind:class="errors.notification_fcm_project_id ? 'invalid' : ''" type="text"
                            id="notification_fcm_project_id" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.notification_fcm_project_id">{{
                            errors.notification_fcm_project_id[0]
                        }}</small>
                    </div>
                    <div class="form-col-12 sm:form-col-6">
                        <label for="notification_fcm_storage_bucket" class="db-field-title required">
                            {{ $t("label.notification_fcm_storage_bucket") }}
                        </label>
                        <input v-model="form.notification_fcm_storage_bucket"
                            v-bind:class="errors.notification_fcm_storage_bucket ? 'invalid' : ''" type="text"
                            id="notification_fcm_storage_bucket" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.notification_fcm_storage_bucket">{{
                            errors.notification_fcm_storage_bucket[0]
                        }}</small>
                    </div>
                    <div class="form-col-12 sm:form-col-6">
                        <label for="notification_fcm_messaging_sender_id" class="db-field-title required">
                            {{ $t("label.notification_fcm_messaging_sender_id") }}
                        </label>
                        <input v-model="form.notification_fcm_messaging_sender_id"
                            v-bind:class="errors.notification_fcm_messaging_sender_id ? 'invalid' : ''" type="text"
                            id="notification_fcm_messaging_sender_id" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.notification_fcm_messaging_sender_id">{{
                            errors.notification_fcm_messaging_sender_id[0]
                        }}</small>
                    </div>
                    <div class="form-col-12 sm:form-col-6">
                        <label for="notification_fcm_app_id" class="db-field-title required">
                            {{ $t("label.notification_fcm_app_id") }}
                        </label>
                        <input v-model="form.notification_fcm_app_id"
                            v-bind:class="errors.notification_fcm_app_id ? 'invalid' : ''" type="text"
                            id="notification_fcm_app_id" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.notification_fcm_app_id">{{
                            errors.notification_fcm_app_id[0]
                        }}</small>
                    </div>
                    <div class="form-col-12 sm:form-col-6">
                        <label for="notification_fcm_measurement_id" class="db-field-title required">
                            {{ $t("label.notification_fcm_measurement_id") }}
                        </label>
                        <input v-model="form.notification_fcm_measurement_id"
                            v-bind:class="errors.notification_fcm_measurement_id ? 'invalid' : ''" type="text"
                            id="notification_fcm_measurement_id" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.notification_fcm_measurement_id">{{
                            errors.notification_fcm_measurement_id[0]
                        }}</small>
                    </div>

                    <div class="form-col-12 sm:form-col-6">
                        <label for="notification_fcm_json_file" class="db-field-title required">
                            {{ $t("label.file") }} ({{ $t("label.json") }})
                        </label>
                        <input @change="changeFile" v-bind:class="errors.notification_fcm_json_file ? 'invalid' : ''"
                            id="notification_fcm_json_file" type="file" class="db-field-control" ref="fileProperty"
                            accept="application/json" />
                        <small class="db-field-alert" v-if="errors.notification_fcm_json_file">{{
                            errors.notification_fcm_json_file[0]
                            }}</small>
                    </div>

                    <div class="form-col-12 border-t pt-5 mt-3">
                        <button type="submit" class="db-btn text-white bg-primary disabled:opacity-50 disabled:cursor-not-allowed" :disabled="isSaving || !notification_fcm_json_file">
                            <template v-if="isSaving">
                                <svg class="inline-block mr-1 animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                                    <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                                </svg>
                                <span>{{ $t('button.updating') }}</span>
                            </template>
                            <template v-else>
                                <i class="lab lab-fill-save"></i>
                                <span>{{ $t("button.save") }}</span>
                            </template>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import LoadingComponent from "../../components/LoadingComponent";
import alertService from "../../../../services/alertService";

export default {
    name: "NotificationComponent",
    components: { LoadingComponent, alertService },
    data() {
        return {
            isRefreshingView: false,
            loading: {
                isActive: false,
            },
            form: {
                notification_fcm_public_vapid_key: "",
                notification_fcm_api_key: "",
                notification_fcm_auth_domain: "",
                notification_fcm_project_id: "",
                notification_fcm_storage_bucket: "",
                notification_fcm_messaging_sender_id: "",
                notification_fcm_app_id: "",
                notification_fcm_measurement_id: "",
            },
            errors: {},
            notification_fcm_json_file: "",
            isSaving: false,
            onUpdateActive: false,
        };
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData: function (showOverlay = true) {
            if (showOverlay) {
                this.loading.isActive = true;
            }
            return this.$store
                .dispatch("notification/lists")
                .then((res) => {
                    if (res && res.data && res.data.data) {
                        Object.assign(this.form, res.data.data);
                    }
                    if (showOverlay) {
                        this.loading.isActive = false;
                    }
                })
                .catch((err) => {
                    if (showOverlay) {
                        this.loading.isActive = false;
                    }
                });
        },
        refreshFromServer: function () {
            if (this.isRefreshingView) {
                return;
            }
            this.isRefreshingView = true;
            this.onUpdateActive = true;
            this.fetchData(false).then(() => {
                alertService.info(this.$t('button.refresh'));
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            }).catch(() => {
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            });
        },
        changeFile: function (e) {
            this.notification_fcm_json_file = e.target.files[0];
        },
        save: function () {
            try {
                this.isSaving = true;
                this.onUpdateActive = true;
                const fd = new FormData();
                fd.append("notification_fcm_public_vapid_key", this.form.notification_fcm_public_vapid_key);
                fd.append("notification_fcm_api_key", this.form.notification_fcm_api_key);
                fd.append("notification_fcm_auth_domain", this.form.notification_fcm_auth_domain);
                fd.append("notification_fcm_project_id", this.form.notification_fcm_project_id);
                fd.append("notification_fcm_storage_bucket", this.form.notification_fcm_storage_bucket);
                fd.append("notification_fcm_messaging_sender_id", this.form.notification_fcm_messaging_sender_id);
                fd.append("notification_fcm_app_id", this.form.notification_fcm_app_id);
                fd.append("notification_fcm_measurement_id", this.form.notification_fcm_measurement_id);
                if (this.notification_fcm_json_file) {
                    fd.append("notification_fcm_json_file", this.notification_fcm_json_file);
                }
                this.$store
                    .dispatch("notification/save", { form: fd })
                    .then((res) => {
                        alertService.successFlip(
                            res.config.method === "post" ?? 0,
                            this.$t("menu.push_notifications")
                        );
                        navigator.serviceWorker.getRegistrations().then(function (registrations) {
                            for (let registration of registrations) {
                                registration.unregister();
                            }
                        });
                        this.$store.dispatch("notification/lists").then((response) => {
                            this.form = {
                                notification_fcm_public_vapid_key: response.data.data.notification_fcm_public_vapid_key,
                                notification_fcm_api_key: response.data.data.notification_fcm_api_key,
                                notification_fcm_auth_domain: response.data.data.notification_fcm_auth_domain,
                                notification_fcm_project_id: response.data.data.notification_fcm_project_id,
                                notification_fcm_storage_bucket: response.data.data.notification_fcm_storage_bucket,
                                notification_fcm_messaging_sender_id: response.data.data.notification_fcm_messaging_sender_id,
                                notification_fcm_app_id: response.data.data.notification_fcm_app_id,
                                notification_fcm_measurement_id: response.data.data.notification_fcm_measurement_id,
                            };
                        }).catch(() => {
                            // Ignore refresh errors after successful save.
                        });
                        this.errors = {};
                        this.notification_fcm_json_file = "";
                        this.$refs.fileProperty.value = null;
                        this.isSaving = false;
                        this.onUpdateActive = false;
                    }).catch((err) => {
                        if (err.response.data.status !== "undefined" && err.response.data.status === false) {
                            alertService.error(err.response.data.message)
                        } else {
                            this.errors = err.response.data.errors;
                        }
                        this.isSaving = false;
                        this.onUpdateActive = false;
                    });
            } catch (err) {
                this.isSaving = false;
                this.onUpdateActive = false;
                alertService.error(err);
            }
        },
    },
};
</script>